import { render, staticRenderFns } from "./SignResult.vue?vue&type=template&id=2b4aa762&scoped=true"
import script from "./SignResult.vue?vue&type=script&lang=js"
export * from "./SignResult.vue?vue&type=script&lang=js"
import style0 from "./SignResult.vue?vue&type=style&index=0&id=2b4aa762&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4aa762",
  null
  
)

export default component.exports